import React from 'react';
import {
  FiCodepen,
  FiCodesandbox,
  FiDatabase
} from 'react-icons/fi';
import { TbApi } from 'react-icons/tb';

import { AgentConfigStepTypeEnum } from '@/types/agent';


export const NODE_TYPE_LABELS: Record<AgentConfigStepTypeEnum, string> = {
  [ AgentConfigStepTypeEnum.LLM ]: 'LLM',
  [ AgentConfigStepTypeEnum.API ]: 'API',
  [ AgentConfigStepTypeEnum.VECTORDB ]: 'VectorDB',
  [ AgentConfigStepTypeEnum.AGENT ]: 'Agent',
  [ AgentConfigStepTypeEnum.START ]: 'Start',
  [ AgentConfigStepTypeEnum.END ]: 'End'
};

export const getNodeTypeLabel = ( type: AgentConfigStepTypeEnum ): string => {
  return NODE_TYPE_LABELS[type] || 'Step';
};

export const NODE_TYPE_ICONS: Partial<Record<AgentConfigStepTypeEnum, React.ReactNode>> = {
  [ AgentConfigStepTypeEnum.LLM ]: <FiCodepen />,
  [ AgentConfigStepTypeEnum.API ]: <TbApi />,
  [ AgentConfigStepTypeEnum.VECTORDB ]: <FiDatabase />,
  [ AgentConfigStepTypeEnum.AGENT ]: <FiCodesandbox />
};

export const getNodeTypeIcon = ( type: AgentConfigStepTypeEnum ): React.ReactNode => {
  return NODE_TYPE_ICONS[type] || null;
};

export type ADDABLE_NODE_TYPES = AgentConfigStepTypeEnum.LLM | AgentConfigStepTypeEnum.API | AgentConfigStepTypeEnum.AGENT;

export const NODE_TYPE_ADD_DESCRIPTIONS: Record<ADDABLE_NODE_TYPES, string> = {
  [ AgentConfigStepTypeEnum.LLM ]: 'Send data to a model',
  [ AgentConfigStepTypeEnum.API ]: 'Send data to an API',
  [ AgentConfigStepTypeEnum.AGENT ]: 'Send data to another agent'
};

export const getNodeTypeAddDescription = ( type: ADDABLE_NODE_TYPES ): string => {
  return NODE_TYPE_ADD_DESCRIPTIONS[type] || 'Node';
};